import { Badge } from "@/components/Badge.tsx";

interface PaymentPlanBadgeProps {
    value: boolean;
}

export function PaymentPlanBadge({ value }: PaymentPlanBadgeProps) {
    return <Badge color={value ? "primary" : "warning"}>{value ? "Post-pay" : "Pre-pay"}</Badge>;
}
